/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_DocsInputs */

const en_directory_agent_readiness_check_docs = /** @type {(inputs: Directory_Agent_Readiness_Check_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentation`)
};

const zh_directory_agent_readiness_check_docs = /** @type {(inputs: Directory_Agent_Readiness_Check_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品文档`)
};

/**
* | output |
* | --- |
* | "Documentation" |
*
* @param {Directory_Agent_Readiness_Check_DocsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_docs = /** @type {((inputs?: Directory_Agent_Readiness_Check_DocsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_DocsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_docs(inputs)
	return zh_directory_agent_readiness_check_docs(inputs)
});
export { directory_agent_readiness_check_docs as "directory.agent_readiness.check.docs" }